import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import image from "../../img/LOGO_AROME.jpg";
import axios from "axios";
import { setTokenWithExpiry, getToken, URL } from "../../utils";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    if (token) {
      const currentUrl =
        sessionStorage.getItem("currentUrl") !== "/login"
          ? sessionStorage.getItem("currentUrl")
          : "/";
      navigate(currentUrl ?? "/");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    if (!trimmedUsername || !trimmedPassword) {
      toast.error("Veuillez remplir tous les champs");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${URL}authentification/user-login`, {
        username: trimmedUsername,
        password: trimmedPassword,
        remember,
      });

      const token = response.data?.access_token;
      if (!token) throw new Error("Token non reçu");

      setTokenWithExpiry(token);
      toast.success("Connexion réussie");

      // Rediriger vers le composant de redirection intelligente
      navigate("/redirect");
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Nom d'utilisateur ou mot de passe incorrect";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  return (
    <>
      <ToastContainer />
      <div className="grid sm:grid-cols-5 h-lvh p-0 overflow-hidden">
        <div className="w-full max-w-md p-4 md:p-6 my-auto mx-auto max-sm:order-2 sm:col-span-2 z-30">
          <form className="space-y-4" onSubmit={handleSubmit}>
            <h5 className="text-3xl font-bold text-gray-900">Connexion</h5>
            <p className="">Entrez les informations</p>

            {/* Champ Nom d'utilisateur */}
            <div>
              <label
                htmlFor="username"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Votre nom d'utilisateur
              </label>
              <input
                type="text"
                name="username"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-400 focus:border-amber-400 block w-full p-2.5"
                placeholder="XYZ123"
                autoComplete="username"
                required
              />
            </div>

            {/* Champ Mot de passe */}
            <div className="relative">
              <label
                htmlFor="password"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Votre mot de passe
              </label>
              <input
                type={passwordVisibility ? "text" : "password"}
                name="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={
                  passwordVisibility ? "Mot de passe" : "••••••••••••"
                }
                className="bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-amber-400 focus:border-amber-400 block w-full p-2.5"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                aria-label={
                  passwordVisibility
                    ? "Cacher le mot de passe"
                    : "Afficher le mot de passe"
                }
                className="absolute top-1/2 right-2 text-gray-700 hover:text-gray-900 cursor-pointer bg-transparent"
                onClick={handleClick}
              >
                <svg
                  className="w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  {passwordVisibility ? (
                    <>
                      <path d="m4 15.6 3.055-3.056A4.913 4.913 0 0 1 7 12.012a5.006 5.006 0 0 1 5-5c.178.009.356.027.532.054l1.744-1.744A8.973 8.973 0 0 0 12 5.012c-5.388 0-10 5.336-10 7A6.49 6.49 0 0 0 4 15.6Z" />
                      <path d="m14.7 10.726 4.995-5.007A.998.998 0 0 0 18.99 4a1 1 0 0 0-.71.305l-4.995 5.007a2.98 2.98 0 0 0-.588-.21l-.035-.01a2.981 2.981 0 0 0-3.584 3.583c0 .012.008.022.01.033.05.204.12.402.211.59l-4.995 4.983a1 1 0 1 0 1.414 1.414l4.995-4.983c.189.091.386.162.59.211.011 0 .021.007.033.01a2.982 2.982 0 0 0 3.584-3.584c0-.012-.008-.023-.011-.035a3.05 3.05 0 0 0-.21-.588Z" />
                      <path d="m19.821 8.605-2.857 2.857a4.952 4.952 0 0 1-5.514 5.514l-1.785 1.785c.767.166 1.55.25 2.335.251 6.453 0 10-5.258 10-7 0-1.166-1.637-2.874-2.179-3.407Z" />
                    </>
                  ) : (
                    <path
                      fillRule="evenodd"
                      d="M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                      clipRule="evenodd"
                    />
                  )}
                </svg>
              </button>
            </div>

            {/* Case à cocher et lien */}
            <div className="flex items-start">
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id="remember"
                    type="checkbox"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                    className="p-2 w-4 h-4 border-2 border-gray-500 rounded bg-gray-50 focus:ring-3 focus:ring-amber-300 form-checkbox"
                  />
                </div>
                <label
                  htmlFor="remember"
                  className="ms-2 text-sm font-medium text-gray-900"
                >
                  Se souvenir de moi
                </label>
              </div>
              {/* <Link
                to="/get-password-reset-mail"
                className="ms-auto text-sm text-amber-600 hover:underline"
              >
                Mot de passe oublié?
              </Link> */}
            </div>

            {/* Bouton de soumission */}
            <button
              type="submit"
              disabled={loading}
              className="w-full text-white bg-amber-600 hover:bg-amber-700 focus:ring-4 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-75"
            >
              {loading ? (
                <div className="flex justify-center items-center">
                  <div className="w-5 h-5 border-2 border-t-amber-100 rounded-full animate-spin"></div>
                </div>
              ) : (
                "Se connecter"
              )}
            </button>
          </form>
        </div>

        {/* Section image */}
        <div className="flex justify-center items-center sm:col-span-3 max-sm:order-1 object-cover z-20 overflow-hidden">
          <img
            src={image}
            alt="Illustration de connexion"
            className="bg-opacity-60 backdrop-blur-sm flex justify-center items-center w-full h-full object-cover rounded-lg shadow-lg max-sm:rounded-none max-sm:shadow-none max-sm:h-auto max-sm:w-full max-sm:object-contain"
          />
        </div>
      </div>
    </>
  );
}
